import * as yup from "yup";
import i18next from "config/i18next";
import { InvoiceValidationSchemaAR } from "./types";

const requiredString = yup.string().required("");
const optionalString = yup.string().optional();

const salePoint = (save: boolean) =>
  yup
    .string()
    .min(4, i18next.t("invoice:salePointError"))
    .concat(save ? optionalString : requiredString);

const invoiceNumber = (save: boolean) =>
  yup
    .string()
    .min(8, i18next.t("invoice:invoiceNumberError"))
    .concat(save ? optionalString : requiredString);

const caeNumber = (save: boolean) =>
  yup
    .string()
    .min(14, i18next.t("invoice:caeNumberError"))
    .concat(save ? optionalString : requiredString);

const invoiceType = (save: boolean) =>
  yup.object({
    name: yup.string().concat(save ? optionalString : requiredString),
  });

const emisionDate = (save: boolean) =>
  yup
    .string()
    .test("requireDatePicker", "", (value) => (save ? true : !!value));

export const validationSchemaAR = (
  save: boolean
): yup.SchemaOf<InvoiceValidationSchemaAR> => {
  return yup.object({
    emisionDate: emisionDate(save),
    invoiceType: invoiceType(save),
    caeNumber: caeNumber(save),
    salePoint: salePoint(save),
    invoiceNumber: invoiceNumber(save),
  });
};
